module.exports = __webpack_public_path__ + "img/logo-sd-cc.2c61b4f9.png";